import PatientSupport from "../../../../src/pages/patient-support/patient-support";
import * as React from 'react';
export default {
  PatientSupport,
  React
};